module.exports = __webpack_public_path__ + "media/components/country-flag/static/hr-fa13404353229f30d836a98113ab3283.svg";